export const normalizeAdnetApiHost = (rawHost: string | undefined | null): string => {
  const host = (rawHost ?? '').trim();
  if (!host || host === '/') {
    return '';
  }

  // TODO: Move this function to utils
  const withoutTrailingSlash = host.endsWith('/') ? host.slice(0, -1) : host;

  if (withoutTrailingSlash === '/hprofits') {
    return '';
  }

  if (withoutTrailingSlash.endsWith('/hprofits')) {
    return withoutTrailingSlash.slice(0, -'/hprofits'.length);
  }

  return withoutTrailingSlash;
};

export const buildAuthApiBase = (adnetApiHost: string): string => {
  return `${adnetApiHost}/hprofits`;
};
